import React from 'react';

import { OsPrompts, checkForOSPrompts } from 'state/location/routes';

class AutoPromptPermissionWithContext extends React.Component<{}> {
  componentDidMount() {
    checkForOSPrompts(`/OS/${OsPrompts.location}`);
  }

  shouldComponentUpdate() {
    return false;
  }

  render() {
    return null;
  }
}

export const AutoPromptLocationPermission = () => {
  return <AutoPromptPermissionWithContext />;
};
